import { render, staticRenderFns } from "./sideTools.vue?vue&type=template&id=5b3338cd&scoped=true&"
import script from "./sideTools.vue?vue&type=script&lang=js&"
export * from "./sideTools.vue?vue&type=script&lang=js&"
import style0 from "./sideTools.vue?vue&type=style&index=0&id=5b3338cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3338cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
